export default {
  namespaced: true,
  state: {
    currentLocale: null,
    currentLokaliseEditMode: null,
    lokaliseEditingAuthenticated: false,
  },
  getters: {
    currentLocale: (state) => state.currentLocale,
  },
  actions: {
    set({ commit }, payload) {
      commit('SET_CURRENT_LOCALE', payload)
    },
    setLokaliseEditingAuthenticated({ commit }, payload) {
      commit('SET_LOKALISE_EDITING_AUTHENTICATED', payload)
    },
  },
  mutations: {
    SET_CURRENT_LOCALE(state, data) {
      state.currentLocale = data.locale
      this.$i18n.locale = data.locale

      if (this.getters['locale/isEditing']) {
        data.window.location.reload()
      }
    },
    SET_CURRENT_LOKALISE_EDIT_MODE(state, data) {
      state.currentLokaliseEditMode = data.mode
      data.window.location.reload()
    },
    SET_LOKALISE_EDITING_AUTHENTICATED(state, data) {
      state.lokaliseEditingAuthenticated = data
    },
  },
}
